import { render } from "./WebhooksModal.vue?vue&type=template&id=c17613e6"
import script from "./WebhooksModal.vue?vue&type=script&lang=js"
export * from "./WebhooksModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__